var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pa-md",attrs:{"id":"import-file"}},[_c('div',{staticClass:"crud-title"},[_c('translate',[_vm._v("AGREEMENTS_REPORT")])],1),_c('crud',{ref:"crudLayout",attrs:{"name":_vm.name,"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }